export default {"src":"/_next/static/media/visibility-off.8407ed14.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};